import { Injectable, inject, signal, computed } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class HuntPackageDetailUiStateService {
  // === Shared state ===
  readonly selectedQueryId = signal<string | null>(null);

  // === Tabs when no query selected ===
  readonly defaultViewTab = signal<'overview' | 'query-logic'>('overview');

  // === Tabs when a query is selected ===
  readonly queryViewTab = signal<'overview' | 'deployment' | 'emulation'>('overview');

  // === Derived states ===
  readonly isQuerySelected = computed(() => this.selectedQueryId() !== null);
  readonly isDefaultView = computed(() => this.selectedQueryId() === null);
  readonly isQueryView = computed(() => this.selectedQueryId() !== null);
}
